module.exports = __webpack_public_path__ + "img/天府新区太平小学.6d421284.jpg";